/**
 * Cadena de carpetas y rutas de matriz (spec 2026-10-06 Fases 1 y 2).
 *
 * Una carpeta es la COLECCIÓN `D/{id}` donde D es el doc que la declara en
 * su `folders[]`. Su matriz es `D/users/{uid}`, salvo el primer nivel (D =
 * folders/{cid}, que es la matriz de la EMPRESA): ahí vive en
 * `folders/{cid}/permisos_carpetas/{id}/users/{uid}`.
 *
 * La cadena (primer nivel → carpeta) sale de la RUTA de la colección, nunca del
 * orden de navegación. La misma sirve para files/{id}.folder (puntero).
 *
 * COPIA en daysi-cloud-functions/scripts/folder_chain_lib.js;
 * folder_chain.test.js exige que den lo mismo. Puro.
 */
export const PERMISOS_CARPETAS = 'permisos_carpetas';

const segs = (p) => (typeof p === 'string' ? p.split('/').filter(Boolean) : []);

export const chainFromCollectionPath = (collectionPath) => {
  const s = segs(collectionPath);
  if (s.length < 3 || s.length % 2 !== 1 || s[0] !== 'folders') return null;
  const cid = s[1];
  const links = [];
  for (let i = 2; i < s.length; i += 2) {
    const collectionId = s[i];
    const declaringDocPath = s.slice(0, i).join('/');
    links.push({
      level: links.length,
      collectionId,
      declaringDocPath,
      collectionPath: s.slice(0, i + 1).join('/'),
      matrixBase: i === 2 ? `folders/${cid}/${PERMISOS_CARPETAS}/${collectionId}` : declaringDocPath,
    });
  }
  return { cid, links };
};

export const companyMatrixPath = (cid, uid) => `folders/${cid}/users/${uid}`;

export const matrixPathOf = (link, uid) => `${link.matrixBase}/users/${uid}`;

export const collectionPathOfPointer = (pointerDocPath) => {
  const s = segs(pointerDocPath);
  if (s.length < 4 || s.length % 2 !== 0 || s[0] !== 'folders') return null;
  return s.slice(0, -1).join('/');
};

const pathString = (p) => {
  if (typeof p === 'string') return p;
  if (p && typeof p.path === 'string') return p.path;
  return null;
};

export const declaringPathOfEntry = (reference) => {
  let p = pathString(reference && reference.path);
  if (!p) return null;
  const k = p.indexOf('/documents/');
  if (k >= 0) p = p.slice(k + '/documents/'.length);
  const s = segs(p);
  if (s.length < 2 || s.length % 2 !== 0 || s[0] !== 'folders') return null;
  return s.join('/');
};

export const collectionPathOfEntry = (reference) => {
  const d = declaringPathOfEntry(reference);
  const id = reference && typeof reference.id === 'string' ? reference.id : null;
  return d && id ? `${d}/${id}` : null;
};

export const matrixPathForFolderRef = (reference, uid) => {
  if (!uid) return null;
  const chain = chainFromCollectionPath(collectionPathOfEntry(reference));
  if (!chain) return null;
  return matrixPathOf(chain.links[chain.links.length - 1], uid);
};

export const isFirstLevelEntry = (reference) => segs(declaringPathOfEntry(reference)).length === 2;

export default chainFromCollectionPath;
